import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=a5cb29a2&"
import script from "./PopupModal.vue?vue&type=script&lang=ts&"
export * from "./PopupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports